import { DocType } from "@megaron/docs-contracts";

import { historyDocRoutes } from "./docRoutes";

export type DocRef = {
  docId: string;
  docType: DocType;
};

export const resolveDocRef = (pathname: string): DocRef | undefined => {
  for (const route of historyDocRoutes) {
    const identifier = route.matchIdentifier(pathname);
    if (identifier) {
      return { docId: `${route.docType}:${identifier}`, docType: route.docType };
    }
  }

  return undefined;
};
